import Vue from 'vue'
import Router from 'vue-router'
import Filial from '../components/filial/Filial.vue'
import Produto from '../components/produto/Produto.vue'
import PontoDeVenda from '../components/pontodevenda/PontoDeVenda.vue'
import CFE from '../components/documento/CFE.vue'
import Pedido from '../components/pedido/Pedido.vue'
import MovimentoFinanceiro from '../components/movimentofinanceiro/MovimentoFinanceiro.vue'
import NFCE from '../components/documento/NFCE.vue'
import NaoFiscal from '../components/documento/NaoFiscal.vue'
import Finalizadora from '../components/finalizadora/Finalizadora.vue'
import Parametro from '../components/parametro/Parametro.vue'
import Recurso from '../components/recurso/Recurso.vue'
import Empregado from '../components/empregado/Empregado.vue'
import Usuario from '../components/usuario/Usuario.vue'
import Home from '../components/home/Home.vue'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta :{
      requiresAuth: true,
      title:'PDVManager'
    }
  },
  {
    path: '/filial',
    name: 'filial',
    component: Filial,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Empresas'
    },
    children: [
      {
        path: '/filial/:id',
        name: 'filialForm',
        component: undefined,
        meta :{
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/produto',
    name: 'produto',
    component: Produto,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Produtos'
    }
  },
  {
    path: '/pontodevenda',
    name: 'pontodevenda',
    component: PontoDeVenda,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Pontos de Vendas'
    }
  },
  {
    path: '/pedido',
    name: 'pedido',
    component: Pedido,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Pedidos'
    }
  },
  {
    path: '/movimentofinanceiro',
    name: 'movimentofinanceiro',
    component: MovimentoFinanceiro,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Movimentos Financeiros'
    }
  },
  {
    path: '/empregado',
    name: 'empregado',
    component: Empregado,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Empregados'
    }
  },
  {
    path: '/finalizadora',
    name: 'finalizadora',
    component: Finalizadora,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Finalizadoras'
    }
  },
  {
    path: '/recurso',
    name: 'recurso',
    component: Recurso,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Recursos Externos'
    }
  },
  {
    path: '/parametro',
    name: 'parametro',
    component: Parametro,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Parâmetros'
    }
  },
  {
    path: '/cfe',
    name: 'cfe',
    component: CFE,
    meta :{
      requiresAuth: true,
      title:'PDVManager - CF-e'
    }
  },
  {
    path: '/nfce',
    name: 'nfce',
    component: NFCE,
    meta :{
      requiresAuth: true,
      title:'PDVManager - NFC-e'
    }
  },
  {
    path: '/naofiscal',
    name: 'naofiscal',
    component: NaoFiscal,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Documentos Não Fiscais'
    }
  },
  {
    path: '/usuario',
    name: 'usuario',
    component: Usuario,
    meta :{
      requiresAuth: true,
      title:'PDVManager - Usuários'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title:'PDVManager - Empresas'
    }
  }
]

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
})

// setando os titulos das paginas
// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title
  })
})

export default router
